import React from "react";
import { Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
const Container = styled.div`
  border: 1px solid lightgray;
  padding: 10px;
  margin-bottom: 8px;
  background-color: ${(props) =>
    props.isDragging
      ? "rgba(14,174,186,.19)"
      : props.is_urgent
      ? "rgba(246,164,9,.19)"
      : "white"};
`;
export default class Task extends React.Component {
  render() {
    return (
      <Draggable draggableId={this.props.task?.id} index={this.props.index}>
        {(provided, snapshot) => (
          <Container
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            isDragging={snapshot.isDragging}
            is_urgent={this.props.task?.details?.is_urgent}
          >
            {" "}
            {this.props.task?.content}{" "}
          </Container>
        )}
      </Draggable>
    );
  }
}
